document.addEventListener('DOMContentLoaded', () => {
  const intervalChecks = setInterval(() => {
      var $form = $('<form>', {
        method: "post",
        action: "/cart/add",
        id: "AddToCartForm-product-upsell--first",
        acceptCharset: "UTF-8",
        class: "product-single__form",
        enctype: "multipart/form-data"
      });
      $("atc:not(atc:has(form))").each(function () {
          $form.append($(this).find('div').first().clone());
      });
      $form.insertBefore($("atc:not(atc:has(form))"))
      $("atc:not(atc:has(form))").remove()
  }, 500);
 
})